/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fields: NonNullable<unknown> }} Body_Assessment_Warning_Llm_Not_ComparableInputs */

const en_us2_body_assessment_warning_llm_not_comparable = /** @type {(inputs: Body_Assessment_Warning_Llm_Not_ComparableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The photo conditions depart from the protocol (${i?.fields}), so this result isn't comparable with your earlier ones.`)
};

const pt_br2_body_assessment_warning_llm_not_comparable = /** @type {(inputs: Body_Assessment_Warning_Llm_Not_ComparableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`As condições da foto fogem do protocolo (${i?.fields}), então este resultado não é comparável com os anteriores.`)
};

const es_419_body_assessment_warning_llm_not_comparable = /** @type {(inputs: Body_Assessment_Warning_Llm_Not_ComparableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Las condiciones de la foto se salen del protocolo (${i?.fields}), así que este resultado no es comparable con los anteriores.`)
};

const pt_pt2_body_assessment_warning_llm_not_comparable = /** @type {(inputs: Body_Assessment_Warning_Llm_Not_ComparableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`As condições da foto fogem ao protocolo (${i?.fields}), por isso este resultado não é comparável com os anteriores.`)
};

const fr_fr2_body_assessment_warning_llm_not_comparable = /** @type {(inputs: Body_Assessment_Warning_Llm_Not_ComparableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Les conditions de la photo s'écartent du protocole (${i?.fields}), donc ce résultat n'est pas comparable aux précédents.`)
};

const de_de2_body_assessment_warning_llm_not_comparable = /** @type {(inputs: Body_Assessment_Warning_Llm_Not_ComparableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Fotobedingungen weichen vom Protokoll ab (${i?.fields}), daher ist dieses Ergebnis nicht mit deinen früheren vergleichbar.`)
};

const it_it2_body_assessment_warning_llm_not_comparable = /** @type {(inputs: Body_Assessment_Warning_Llm_Not_ComparableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le condizioni della foto si discostano dal protocollo (${i?.fields}), quindi questo risultato non è confrontabile con i precedenti.`)
};

/**
* | output |
* | --- |
* | "The photo conditions depart from the protocol ({fields}), so this result isn't comparable with your earlier ones." |
*
* @param {Body_Assessment_Warning_Llm_Not_ComparableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_warning_llm_not_comparable = /** @type {((inputs: Body_Assessment_Warning_Llm_Not_ComparableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Warning_Llm_Not_ComparableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_warning_llm_not_comparable(inputs)
	if (locale === "es-419") return es_419_body_assessment_warning_llm_not_comparable(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_warning_llm_not_comparable(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_warning_llm_not_comparable(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_warning_llm_not_comparable(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_warning_llm_not_comparable(inputs)
	return en_us2_body_assessment_warning_llm_not_comparable(inputs)
});
export { body_assessment_warning_llm_not_comparable as "body-assessment.warning.llm_not_comparable" }